export default "__VITE_ASSET__f4c12638__"